import React, { useState } from 'react';
import ProductList from './ProductList';
import ProductForm from './ProductForm';
import { removeProduct } from '../../services/sellerProductService';
import { useSearchParams } from 'react-router-dom';
import Icon from '../Icon';

function ProductsTab({
  seller,
  products,
  groups,
  loadProductsWithVariants,
  loading,
}) {
  const [params, setParams] = useSearchParams();
  const [showForm, setShowForm] = useState(params.get('action') === 'create');
  const [editingProduct, setEditingProduct] = useState(null);
  const search = params.get('q') || '';
  const [availability, setAvailability] = useState('all');
  const visible = products.filter((product) => {
    const matches =
      `${product.title} ${product.platformSku || ''} ${product.sellerSku || ''}`
        .toLocaleLowerCase('ru')
        .includes(search.toLocaleLowerCase('ru'));
    const active = product.variants?.some((v) => v.price > 0 && v.stock > 0);
    return (
      matches &&
      (availability === 'all' || (availability === 'active' ? active : !active))
    );
  });

  const handleEdit = (product) => {
    setEditingProduct(product);
    setShowForm(true);
  };

  const handleDelete = async (productId) => {
    if (!window.confirm('Удалить товар?')) return;
    try {
      await removeProduct(productId, seller.id);
      loadProductsWithVariants();
    } catch (err) {
      alert('Ошибка при удалении');
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingProduct(null);
    setParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete('action');
        return next;
      },
      { replace: true }
    );
  };

  const handleFormSuccess = () => {
    handleFormClose();
    loadProductsWithVariants();
  };

  return (
    <>
      {!showForm ? (
        <>
          <div className="seller-page-heading">
            <div>
              <span className="eyebrow">АССОРТИМЕНТ</span>
              <h1>
                Товары <span className="seller-count">{products.length}</span>
              </h1>
              <p>Карточки, варианты и готовность к продаже.</p>
            </div>
            <button
              onClick={() => setShowForm(true)}
              className="btn btn-primary"
            >
              <Icon name="plus" size={18} />
              Создать товар
            </button>
          </div>
          <div className="seller-list-tools">
            <label className="seller-search">
              <Icon name="search" size={18} />
              <input
                aria-label="Поиск товаров продавца"
                placeholder="Название или артикул"
                value={search}
                onChange={(e) =>
                  setParams(
                    (current) => {
                      const next = new URLSearchParams(current);
                      next.set('q', e.target.value);
                      return next;
                    },
                    { replace: true }
                  )
                }
              />
            </label>
            <select
              aria-label="Доступность товаров"
              value={availability}
              onChange={(e) => setAvailability(e.target.value)}
            >
              <option value="all">Все товары</option>
              <option value="active">В продаже</option>
              <option value="inactive">Не в продаже</option>
            </select>
            <span>
              {visible.length} из {products.length}
            </span>
          </div>
          {loading ? (
            <div className="seller-panel seller-muted">
              Загружаем ассортимент…
            </div>
          ) : visible.length === 0 ? (
            <div className="market-empty">
              <Icon name="box" size={32} />
              <h3>
                {products.length
                  ? 'Подходящих товаров нет'
                  : 'Добавьте первый товар'}
              </h3>
              <p>
                {products.length
                  ? 'Измените запрос или фильтр доступности.'
                  : 'Создайте карточку, загрузите фото и добавьте варианты.'}
              </p>
            </div>
          ) : (
            <ProductList
              products={visible}
              groups={groups}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          )}
        </>
      ) : (
        <ProductForm
          seller={seller}
          product={editingProduct}
          groups={groups}
          onClose={handleFormClose}
          onSuccess={handleFormSuccess}
        />
      )}
    </>
  );
}

export default ProductsTab;
